import MediaPreviewEmbed from '../components/MediaPreviewEmbed/MediaPreviewEmbed';
import MediaPreviewEmbed2 from '../components/MediaPreviewEmbed2/MediaPreviewEmbed2.js';
import MediaPreviewFile from '../components/MediaPreviewFile/MediaPreviewFile';
import MediaPreviewFile2 from '../components/MediaPreviewFile2/MediaPreviewFile2.js';
import MediaPreviewFileWithImage2 from '../components/MediaPreviewFileWithImage2/MediaPreviewFileWithImage2.js';
import MediaPreviewImage from '../components/MediaPreviewImage/MediaPreviewImage';
import MediaPreviewImage2 from '../components/MediaPreviewImage2/MediaPreviewImage2.js';
import MediaPreviewLink from '../components/MediaPreviewLink/MediaPreviewLink';
import MediaPreviewLink2 from '../components/MediaPreviewLink2/MediaPreviewLink2.js';
import MediaPreviewNoop from '../components/MediaPreviewNoop/MediaPreviewNoop';
import MediaPreviewOpenGraph from '../components/MediaPreviewOpenGraph/MediaPreviewOpenGraph';
import MediaPreviewPdf from '../components/MediaPreviewPdf/MediaPreviewPdf';
import MediaPreviewPdf2 from '../components/MediaPreviewPdf2/MediaPreviewPdf2.js';
import MediaPreviewVideo from '../components/MediaPreviewVideo/MediaPreviewVideo';
import MediaPreviewVideo2 from '../components/MediaPreviewVideo2/MediaPreviewVideo2.js';
import MediaPreviewWebsiteLink2 from '../components/MediaPreviewWebsiteLink2/MediaPreviewWebsiteLink2.js';
import MediaPreviewWebsitePreview2 from '../components/MediaPreviewWebsitePreview2/MediaPreviewWebsitePreview2.js';
import MediaPreviewYoutube from '../components/MediaPreviewYoutube/MediaPreviewYoutube';
import MediaPreviewYoutubeNoCookie from '../components/MediaPreviewYoutubeNoCookie/MediaPreviewYoutubeNoCookie';
import MediaPreviewYoutubeNoCookie2 from '../components/MediaPreviewYoutubeNoCookie2/MediaPreviewYoutubeNoCookie2.js';
import MediaPreviewYoutubeShort from '../components/MediaPreviewYoutubeShort/MediaPreviewYoutubeShort';
import MediaPreviewYoutubeShort2 from '../components/MediaPreviewYoutubeShort2/MediaPreviewYoutubeShort2.js';
import * as MediaPreviewType from '../constants/MediaPreviewType';
/* eslint-disable no-console */

export const getMediaPreviewComponent = (mediaPreviewType: number, type?: string) => {
  switch (type) {
    case 'image':
    case 'linked-image':
      return MediaPreviewImage2;
    case 'link':
      return MediaPreviewLink2;
    case 'youtube-short':
      return MediaPreviewYoutubeShort2;
    case 'youtube-nocookie':
      return MediaPreviewYoutubeNoCookie2;
    case 'instagram':
    case 'soundcloud':
    case 'twitter':
    case 'google-maps':
    case 'vimeo':
      return MediaPreviewEmbed2;
    case 'file':
      return MediaPreviewFile2;
    case 'video':
      return MediaPreviewVideo2;
    case 'youtube-embed':
      return MediaPreviewYoutube;
    case 'website-link':
      return MediaPreviewWebsiteLink2;
    case 'website-preview':
      return MediaPreviewWebsitePreview2;
    case 'file-with-image':
      return MediaPreviewFileWithImage2;
    case 'pdf':
      return MediaPreviewPdf2;
    case undefined:
      return MediaPreviewNoop;
    default:
      //   console.error(`UNSUPPORTED MEDIA PREVIEW TYPE ${mediaPreviewType}`);
      // return MediaPreviewUnsupported;
      break;
  }
  switch (mediaPreviewType) {
    case MediaPreviewType.Video:
      return MediaPreviewVideo;
    case MediaPreviewType.Image:
      return MediaPreviewImage;
    case MediaPreviewType.Link:
      return MediaPreviewLink;
    case MediaPreviewType.EmbedGoogleMaps:
    case MediaPreviewType.EmbedInstagram:
    case MediaPreviewType.EmbedPdf:
    case MediaPreviewType.EmbedSoundcloud:
    case MediaPreviewType.EmbedTwitter:
    case MediaPreviewType.EmbedVimeo:
      return MediaPreviewEmbed;
    case MediaPreviewType.EmbedYoutube:
      return MediaPreviewYoutube;
    case MediaPreviewType.Pdf:
      return MediaPreviewPdf;
    case MediaPreviewType.OpenGraph:
      return MediaPreviewOpenGraph;
    case MediaPreviewType.None:
      return MediaPreviewNoop;
    case MediaPreviewType.File:
      return MediaPreviewFile;
    case MediaPreviewType.EmbedYoutubeNoCookie:
      return MediaPreviewYoutubeNoCookie;
    case MediaPreviewType.EmbedYoutubeShort:
      return MediaPreviewYoutubeShort;
    default:
      throw new Error(`unsupported media preview type`);
  }
};
